import { ɵɵdefineInjectable, ɵɵinject, Injectable, Component, Inject, ViewChild, ElementRef, Input, NgModule } from '@angular/core';
import { HttpHeaders, HttpClient, HttpClientModule } from '@angular/common/http';
import { messageType, MessageService, MessageModule } from 'ui-message-angular';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DOCUMENT, CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { AutofillMonitor } from '@angular/cdk/text-field';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from 'ui-message-angular';
import * as ɵngcc3 from '@angular/router';
import * as ɵngcc4 from '@angular/cdk/text-field';
import * as ɵngcc5 from '@angular/forms';
import * as ɵngcc6 from '@angular/common';

const _c0 = ["inputUserID"];
const _c1 = ["inputPassword"];
function LogonComponent_i_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 14);
} }
const msgStore = [
    { msgCat: 'EXCEPTION',
        msgName: 'GENERIC',
        msgText: {
            EN: { shortText: 'Exception Occurs',
                longText: '%s1' }
        }
    }
];

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
class LogonService {
    constructor(http, messageService) {
        this.http = http;
        this.messageService = messageService;
        this.host = '';
        this.messageService.setMessageStore(msgStore, 'EN');
    }
    setHost(host) {
        this.host = host;
    }
    logon(userid, password) {
        return this.http.post(this.host ? this.host + '/api/logon' : 'api/logon', { username: userid, password: password }, httpOptions).pipe(catchError(this.handleError('Logon')));
    }
    logout() {
        return this.http.delete(this.host ? this.host + '/api/logout' : 'api/logout', httpOptions).pipe(catchError(this.handleError('Logout')));
    }
    session() {
        return this.http.get(this.host ? this.host + '/api/session' : 'api/session', httpOptions).pipe(catchError(this.handleError('Get session')));
    }
    /**
     * this method is called during logon component initialization. It tries to get the session,
     * but without raising any errors.
     */
    try_get_session() {
        return this.http.get(this.host ? this.host + '/api/session' : 'api/session', httpOptions);
    }
    query(queryObject) {
        return this.http.post(this.host ? this.host + '/api/query' : 'api/query', queryObject, httpOptions).pipe(catchError(this.handleError('query')));
    }
    read(instanceGUID) {
        return this.http.get(this.host ? this.host + `/api/entity/instance/${instanceGUID}` : `api/entity/instance/${instanceGUID}`)
            .pipe(catchError(this.handleError('read')));
    }
    handleError(operation = 'operation', result) {
        return (error) => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            this.messageService.addMessage('EXCEPTION', 'GENERIC', messageType.Exception, JSON.stringify(error));
            // Let the app keep running by returning an empty result.
            return of(result);
        };
    }
}
LogonService.ɵfac = function LogonService_Factory(t) { return new (t || LogonService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.MessageService)); };
LogonService.ɵprov = ɵɵdefineInjectable({ factory: function LogonService_Factory() { return new LogonService(ɵɵinject(HttpClient), ɵɵinject(MessageService)); }, token: LogonService, providedIn: "root" });
LogonService.ctorParameters = () => [
    { type: HttpClient },
    { type: MessageService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LogonService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.MessageService }]; }, null); })();

class User {
}
class PluralField {
}
class QueryObject {
}
class Projection {
}
class Selection {
}
class Sort {
}
class Session {
}

class LogonComponent {
    constructor(document, router, route, autofill, logonService, messageService) {
        this.document = document;
        this.router = router;
        this.route = route;
        this.autofill = autofill;
        this.logonService = logonService;
        this.messageService = messageService;
        this.user = new User;
        this.isWaiting = false;
        this.title = 'Logon Portal';
        this.userLabel = 'User ID';
        this.pwdLabel = 'Password';
        this.btnLabel = 'Logon';
        this.redirectUrl = '';
        this.redirectPath = '';
        this.host = '';
    }
    ngOnInit() {
        this.autofill.monitor(this.inputUserID.nativeElement);
        this.autofill.monitor(this.inputPassword.nativeElement);
        if (this.route.snapshot.data['title']) {
            this.title = this.route.snapshot.data['title'];
        }
        if (this.route.snapshot.data['userLabel']) {
            this.userLabel = this.route.snapshot.data['userLabel'];
        }
        if (this.route.snapshot.data['pwdLabel']) {
            this.pwdLabel = this.route.snapshot.data['pwdLabel'];
        }
        if (this.route.snapshot.data['btnLabel']) {
            this.btnLabel = this.route.snapshot.data['btnLabel'];
        }
        if (this.route.snapshot.data['redirectUrl']) {
            this.redirectUrl = this.route.snapshot.data['redirectUrl'];
        }
        if (this.route.snapshot.data['redirectPath']) {
            this.redirectPath = this.route.snapshot.data['redirectPath'];
        }
        if (this.route.snapshot.data['host']) {
            this.host = this.route.snapshot.data['host'];
        }
        this.logonService.setHost(this.host);
    }
    ngOnDestroy() {
        this.autofill.stopMonitoring(this.inputUserID.nativeElement);
        this.autofill.stopMonitoring(this.inputPassword.nativeElement);
    }
    logon() {
        this.isWaiting = true;
        this.logonService.logon(this.user.userid, this.user.password).subscribe(data => {
            this.isWaiting = false;
            if (!data) {
                return;
            }
            if (data.err) {
                if (Array.isArray(data.err)) {
                    data.err.forEach(err => this.messageService.add(err));
                }
                else {
                    this.messageService.report(data.err);
                }
            }
            else {
                this.user.displayName = data.user['DISPLAY_NAME'];
                this.user.userid = data.user['USER_ID'];
                this.user.username = data.user['USER_NAME'];
                this.user.locked = data.user['LOCK'];
                this.user.pwdState = data.user['PWD_STATE'];
                this.user.name = data.user['GIVEN_NAME'];
                if (this.redirectPath) {
                    this.router.navigateByUrl(this.redirectPath);
                }
                else if (this.redirectUrl) {
                    this.document.location.href = this.redirectUrl;
                }
            }
        });
    }
}
LogonComponent.ɵfac = function LogonComponent_Factory(t) { return new (t || LogonComponent)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.AutofillMonitor), ɵngcc0.ɵɵdirectiveInject(LogonService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.MessageService)); };
LogonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LogonComponent, selectors: [["dk-logon"]], viewQuery: function LogonComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c0, true, ElementRef);
        ɵngcc0.ɵɵstaticViewQuery(_c1, true, ElementRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputUserID = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputPassword = _t.first);
    } }, inputs: { title: "title", userLabel: "userLabel", pwdLabel: "pwdLabel", btnLabel: "btnLabel", redirectUrl: "redirectUrl", redirectPath: "redirectPath", host: "host" }, decls: 20, vars: 8, consts: [[1, "dk-form-logon", 3, "ngSubmit"], [3, "disabled"], [1, "text-center", "dk-mb-4"], [1, "dk-form-title", "dk-mb-3", "font-weight-normal"], [1, "dk-message-area"], [1, "dk-form-label-group"], ["type", "text", "id", "inputUserID", "name", "inputUserID", "placeholder", "User ID", "required", "", "autofocus", "", 1, "form-control", "dk-form-control", 3, "ngModel", "ngModelChange"], ["inputUserID", ""], ["for", "inputUserID"], ["type", "password", "id", "inputPassword", "name", "inputPassword", "placeholder", "Password", "required", "", 1, "form-control", "dk-form-control", 3, "ngModel", "ngModelChange"], ["inputPassword", ""], ["for", "inputPassword"], ["type", "submit", 1, "btn", "dk-btn-lg", "btn-primary", "btn-block"], ["class", "fas fa-spinner fa-spin", 4, "ngIf"], [1, "fas", "fa-spinner", "fa-spin"]], template: function LogonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵlistener("ngSubmit", function LogonComponent_Template_form_ngSubmit_0_listener() { return ctx.logon(); });
        ɵngcc0.ɵɵelementStart(1, "fieldset", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "h1", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelement(6, "dk-message");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵelementStart(8, "input", 6, 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function LogonComponent_Template_input_ngModelChange_8_listener($event) { return ctx.user.userid = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "label", 8);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 5);
        ɵngcc0.ɵɵelementStart(13, "input", 9, 10);
        ɵngcc0.ɵɵlistener("ngModelChange", function LogonComponent_Template_input_ngModelChange_13_listener($event) { return ctx.user.password = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "label", 11);
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "button", 12);
        ɵngcc0.ɵɵtemplate(18, LogonComponent_i_18_Template, 1, 0, "i", 13);
        ɵngcc0.ɵɵtext(19);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.isWaiting);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.user.userid);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.userLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.user.password);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.pwdLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isWaiting);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.btnLabel, " ");
    } }, directives: [ɵngcc5.ɵangular_packages_forms_forms_y, ɵngcc5.NgControlStatusGroup, ɵngcc5.NgForm, ɵngcc2.MessageComponent, ɵngcc5.DefaultValueAccessor, ɵngcc5.RequiredValidator, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc6.NgIf], styles: [".dk-form-logon[_ngcontent-%COMP%]{--input-padding-x:0.75rem;--input-padding-y:0.75rem;line-height:1.5;margin:0 auto;max-width:420px;padding:15px;width:100%}.dk-form-logon[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{font-size:1rem;margin-bottom:.5rem}.dk-message-area[_ngcontent-%COMP%]{margin-bottom:.5rem}.dk-mb-3[_ngcontent-%COMP%]{margin-bottom:1rem}.dk-mb-4[_ngcontent-%COMP%]{margin-bottom:1.5rem}.dk-form-title[_ngcontent-%COMP%]{color:inherit;font-family:inherit;font-size:1.75rem;line-height:1.2}.dk-form-label-group[_ngcontent-%COMP%]{margin-bottom:1rem;position:relative}.dk-form-control[_ngcontent-%COMP%]{border-radius:.25rem;font-size:1rem;height:calc(2.9rem + 2px)}.dk-form-label-group[_ngcontent-%COMP%] > input[_ngcontent-%COMP%], .dk-form-label-group[_ngcontent-%COMP%] > label[_ngcontent-%COMP%]{padding:var(--input-padding-y) var(--input-padding-x)}.dk-form-label-group[_ngcontent-%COMP%] > label[_ngcontent-%COMP%]{border:1px solid transparent;border-radius:.25rem;color:#495057;display:block;left:0;line-height:1.5;margin-bottom:0;position:absolute;top:0;transition:all .1s ease-in-out;width:100%}.dk-form-label-group[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:-ms-input-placeholder{color:transparent}.dk-form-label-group[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-moz-placeholder{color:transparent}.dk-form-label-group[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::placeholder{color:transparent}.dk-form-label-group[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:-webkit-autofill{-webkit-animation-name:cdk-text-field-autofill-start;-webkit-transition:background-color 50000s ease-in-out 0s;animation-name:cdk-text-field-autofill-start;transition:background-color 50000s ease-in-out 0s}.dk-form-label-group[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:not(:-webkit-autofill){-webkit-animation-name:cdk-text-field-autofill-end;animation-name:cdk-text-field-autofill-end}.dk-form-label-group[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:not(:-moz-placeholder-shown){padding-bottom:calc(var(--input-padding-y)/3);padding-top:calc(var(--input-padding-y) + var(--input-padding-y)*0.66667)}.dk-form-label-group[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:not(:-ms-input-placeholder){padding-bottom:calc(var(--input-padding-y)/3);padding-top:calc(var(--input-padding-y) + var(--input-padding-y)*0.66667)}.dk-form-label-group[_ngcontent-%COMP%]   input.cdk-text-field-autofilled[_ngcontent-%COMP%], .dk-form-label-group[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:not(:placeholder-shown){padding-bottom:calc(var(--input-padding-y)/3);padding-top:calc(var(--input-padding-y) + var(--input-padding-y)*0.66667)}.dk-form-label-group[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:not(:-moz-placeholder-shown) ~ label[_ngcontent-%COMP%]{color:#777;font-size:.75rem;padding-bottom:calc(var(--input-padding-y)/3);padding-top:calc(var(--input-padding-y)/3)}.dk-form-label-group[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:not(:-ms-input-placeholder) ~ label[_ngcontent-%COMP%]{color:#777;font-size:.75rem;padding-bottom:calc(var(--input-padding-y)/3);padding-top:calc(var(--input-padding-y)/3)}.dk-form-label-group[_ngcontent-%COMP%]   input.cdk-text-field-autofilled[_ngcontent-%COMP%] ~ label[_ngcontent-%COMP%], .dk-form-label-group[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:not(:placeholder-shown) ~ label[_ngcontent-%COMP%]{color:#777;font-size:.75rem;padding-bottom:calc(var(--input-padding-y)/3);padding-top:calc(var(--input-padding-y)/3)}.dk-btn-lg[_ngcontent-%COMP%]{border-radius:.3rem;font-size:1.25rem;line-height:1.5;padding:.5rem 1rem}"] });
LogonComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Router },
    { type: ActivatedRoute },
    { type: AutofillMonitor },
    { type: LogonService },
    { type: MessageService }
];
LogonComponent.propDecorators = {
    inputUserID: [{ type: ViewChild, args: ['inputUserID', { read: ElementRef, static: true },] }],
    inputPassword: [{ type: ViewChild, args: ['inputPassword', { read: ElementRef, static: true },] }],
    title: [{ type: Input }],
    userLabel: [{ type: Input }],
    pwdLabel: [{ type: Input }],
    btnLabel: [{ type: Input }],
    redirectUrl: [{ type: Input }],
    redirectPath: [{ type: Input }],
    host: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LogonComponent, [{
        type: Component,
        args: [{
                selector: 'dk-logon',
                template: "<form class=\"dk-form-logon\" (ngSubmit)=\"logon()\">\n  <fieldset [disabled]=\"isWaiting\">\n    <div class=\"text-center dk-mb-4\">\n      <!--<img class=\"mb-4\" src=\"https://getbootstrap.com/assets/brand/bootstrap-solid.svg\" alt=\"\" width=\"72\" height=\"72\">-->\n      <h1 class=\"dk-form-title dk-mb-3 font-weight-normal\">{{title}}</h1>\n    </div>\n\n    <div class=\"dk-message-area\">\n      <dk-message></dk-message>\n    </div>\n\n    <div class=\"dk-form-label-group\">\n      <input type=\"text\" id=\"inputUserID\" name=\"inputUserID\" #inputUserID class=\"form-control dk-form-control\"\n             [(ngModel)]=\"user.userid\" placeholder=\"User ID\" required=\"\" autofocus=\"\">\n      <label for=\"inputUserID\">{{userLabel}}</label>\n    </div>\n\n    <div class=\"dk-form-label-group\">\n      <input type=\"password\" id=\"inputPassword\" name=\"inputPassword\" #inputPassword class=\"form-control dk-form-control\"\n             [(ngModel)]=\"user.password\" placeholder=\"Password\" required=\"\">\n      <label for=\"inputPassword\">{{pwdLabel}}</label>\n    </div>\n\n    <button class=\"btn dk-btn-lg btn-primary btn-block\" type=\"submit\">\n      <i *ngIf=\"isWaiting\" class=\"fas fa-spinner fa-spin\"></i> {{btnLabel}}\n    </button>\n  </fieldset>\n</form>\n\n",
                styles: [".dk-form-logon{--input-padding-x:0.75rem;--input-padding-y:0.75rem;line-height:1.5;margin:0 auto;max-width:420px;padding:15px;width:100%}.dk-form-logon label{font-size:1rem;margin-bottom:.5rem}.dk-message-area{margin-bottom:.5rem}.dk-mb-3{margin-bottom:1rem}.dk-mb-4{margin-bottom:1.5rem}.dk-form-title{color:inherit;font-family:inherit;font-size:1.75rem;line-height:1.2}.dk-form-label-group{margin-bottom:1rem;position:relative}.dk-form-control{border-radius:.25rem;font-size:1rem;height:calc(2.9rem + 2px)}.dk-form-label-group>input,.dk-form-label-group>label{padding:var(--input-padding-y) var(--input-padding-x)}.dk-form-label-group>label{border:1px solid transparent;border-radius:.25rem;color:#495057;display:block;left:0;line-height:1.5;margin-bottom:0;position:absolute;top:0;transition:all .1s ease-in-out;width:100%}.dk-form-label-group input:-ms-input-placeholder{color:transparent}.dk-form-label-group input::-moz-placeholder{color:transparent}.dk-form-label-group input::placeholder{color:transparent}.dk-form-label-group input:-webkit-autofill{-webkit-animation-name:cdk-text-field-autofill-start;-webkit-transition:background-color 50000s ease-in-out 0s;animation-name:cdk-text-field-autofill-start;transition:background-color 50000s ease-in-out 0s}.dk-form-label-group input:not(:-webkit-autofill){-webkit-animation-name:cdk-text-field-autofill-end;animation-name:cdk-text-field-autofill-end}.dk-form-label-group input:not(:-moz-placeholder-shown){padding-bottom:calc(var(--input-padding-y)/3);padding-top:calc(var(--input-padding-y) + var(--input-padding-y)*0.66667)}.dk-form-label-group input:not(:-ms-input-placeholder){padding-bottom:calc(var(--input-padding-y)/3);padding-top:calc(var(--input-padding-y) + var(--input-padding-y)*0.66667)}.dk-form-label-group input.cdk-text-field-autofilled,.dk-form-label-group input:not(:placeholder-shown){padding-bottom:calc(var(--input-padding-y)/3);padding-top:calc(var(--input-padding-y) + var(--input-padding-y)*0.66667)}.dk-form-label-group input:not(:-moz-placeholder-shown)~label{color:#777;font-size:.75rem;padding-bottom:calc(var(--input-padding-y)/3);padding-top:calc(var(--input-padding-y)/3)}.dk-form-label-group input:not(:-ms-input-placeholder)~label{color:#777;font-size:.75rem;padding-bottom:calc(var(--input-padding-y)/3);padding-top:calc(var(--input-padding-y)/3)}.dk-form-label-group input.cdk-text-field-autofilled~label,.dk-form-label-group input:not(:placeholder-shown)~label{color:#777;font-size:.75rem;padding-bottom:calc(var(--input-padding-y)/3);padding-top:calc(var(--input-padding-y)/3)}.dk-btn-lg{border-radius:.3rem;font-size:1.25rem;line-height:1.5;padding:.5rem 1rem}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc3.Router }, { type: ɵngcc3.ActivatedRoute }, { type: ɵngcc4.AutofillMonitor }, { type: LogonService }, { type: ɵngcc2.MessageService }]; }, { title: [{
            type: Input
        }], userLabel: [{
            type: Input
        }], pwdLabel: [{
            type: Input
        }], btnLabel: [{
            type: Input
        }], redirectUrl: [{
            type: Input
        }], redirectPath: [{
            type: Input
        }], host: [{
            type: Input
        }], inputUserID: [{
            type: ViewChild,
            args: ['inputUserID', { read: ElementRef, static: true }]
        }], inputPassword: [{
            type: ViewChild,
            args: ['inputPassword', { read: ElementRef, static: true }]
        }] }); })();

class LandingPageComponent {
    constructor(router, logonService) {
        this.router = router;
        this.logonService = logonService;
    }
    ngOnInit() {
    }
    logout() {
        this.logonService.logout().subscribe(data => {
            this.router.navigateByUrl('');
        });
    }
    session() {
        this.logonService.session().subscribe(data => {
            this.result = data;
        });
    }
    query() {
        const queryObject = {
            ENTITY_ID: 'person',
            RELATION_ID: 'r_user'
        };
        this.logonService.query(queryObject).subscribe(data => this.result = data);
    }
    read() {
        this.logonService.read('2FBE7490E10F11E8A90957FA46F2CECA').subscribe(data => this.result = data);
    }
}
LandingPageComponent.ɵfac = function LandingPageComponent_Factory(t) { return new (t || LandingPageComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Router), ɵngcc0.ɵɵdirectiveInject(LogonService)); };
LandingPageComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LandingPageComponent, selectors: [["dk-landing-page"]], decls: 15, vars: 3, consts: [["role", "group", 1, "btn-group"], ["type", "button", 1, "btn", "dk-btn-lg", "btn-primary", 3, "click"], [1, "container"]], template: function LandingPageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "h4");
        ɵngcc0.ɵɵtext(1, " Logon Successfully\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 0);
        ɵngcc0.ɵɵelementStart(3, "button", 1);
        ɵngcc0.ɵɵlistener("click", function LandingPageComponent_Template_button_click_3_listener() { return ctx.logout(); });
        ɵngcc0.ɵɵtext(4, "Logout");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "button", 1);
        ɵngcc0.ɵɵlistener("click", function LandingPageComponent_Template_button_click_5_listener() { return ctx.session(); });
        ɵngcc0.ɵɵtext(6, "Get Session");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 1);
        ɵngcc0.ɵɵlistener("click", function LandingPageComponent_Template_button_click_7_listener() { return ctx.query(); });
        ɵngcc0.ɵɵtext(8, "Query");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "button", 1);
        ɵngcc0.ɵɵlistener("click", function LandingPageComponent_Template_button_click_9_listener() { return ctx.read(); });
        ɵngcc0.ɵɵtext(10, "Read");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 2);
        ɵngcc0.ɵɵelementStart(12, "pre");
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "json");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(13);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(14, 1, ctx.result));
    } }, pipes: [ɵngcc6.JsonPipe], encapsulation: 2 });
LandingPageComponent.ctorParameters = () => [
    { type: Router },
    { type: LogonService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LandingPageComponent, [{
        type: Component,
        args: [{
                selector: 'dk-landing-page',
                template: "<h4>\n  Logon Successfully\n</h4>\n\n<div class=\"btn-group\" role=\"group\">\n  <button type=\"button\" class=\"btn dk-btn-lg btn-primary\" (click)=\"logout()\">Logout</button>\n  <button type=\"button\" class=\"btn dk-btn-lg btn-primary\" (click)=\"session()\">Get Session</button>\n  <button type=\"button\" class=\"btn dk-btn-lg btn-primary\" (click)=\"query()\">Query</button>\n  <button type=\"button\" class=\"btn dk-btn-lg btn-primary\" (click)=\"read()\">Read</button>\n</div>\n<div class=\"container\">\n  <pre>{{result | json}}</pre>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc3.Router }, { type: LogonService }]; }, null); })();

class LogonModule {
}
LogonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LogonModule });
LogonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function LogonModule_Factory(t) { return new (t || LogonModule)(); }, imports: [[
            CommonModule,
            BrowserModule,
            FormsModule,
            HttpClientModule,
            MessageModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LogonModule, { declarations: function () { return [LogonComponent, LandingPageComponent]; }, imports: function () { return [CommonModule,
        BrowserModule,
        FormsModule,
        HttpClientModule,
        MessageModule]; }, exports: function () { return [LogonComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LogonModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    BrowserModule,
                    FormsModule,
                    HttpClientModule,
                    MessageModule
                ],
                declarations: [LogonComponent, LandingPageComponent],
                exports: [LogonComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of logon
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LandingPageComponent, LogonComponent, LogonModule, LogonService, PluralField, Projection, QueryObject, Selection, Session, Sort, User };

//# sourceMappingURL=ui-logon-angular.js.map